import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDisciplinaryRecords } from '../../../store/actions/disciplinaryRecordsActions'
import moment from 'moment'
import { Link } from 'react-router-dom'
import SearchField from '../../elements/SearchField'
import Loader from '../../elements/Loader'
import DataTable from '../../elements/DataTable'
import { tableHeadersFields } from '../../../utils'
import EmptyState from '../../elements/EmptyState'
import ModalDialog from '../../layouts/ModalDialog'
import PenaltyTypePill from '../../elements/PenaltyTypePill'
import StatusPill from '../../elements/StatusPill'
import DisciplinaryRecordDetails from './DisciplinaryRecordDetails'

const StudentDisciplinary = ({student}) => {
  const disciplinaryRecordsSelector = useSelector(state => state.disciplinaryRecords)

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 25
  })

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchDisciplinaryRecords(student._id, ``, pagination.page, pagination.perPage))
      
    return () => {
      
    }
  }, [dispatch, pagination.page, pagination.perPage, student._id])
  

  const columnWidths = {
    description: 'w-4/12',
    students:'w-3/12',
    penalty: 'w-1/12',
    penaltyStatus: 'w-2/12',
    dateRecorded: 'w-2/12',
  }
        
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{
      openDisciplinaryRecord(disciplinaryRecordsSelector?.disciplinaryRecords?.records[index])
    }
  }
  
  const columnDataStyles = {}
  
  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []
    console.log('invoices data set -> ', dataSet)
    dataSet.forEach((item, itemIndex) => {
      data.push(
        {
          description: <div className='pr-[20px]'>
            <p className='text-[14px] text-gray-700'>{item.description.substring(0,100)}{item.description.length > 150 ? '...' : ''}</p>
            <p className='text-xs mt-[10px] font-[500]'><span className='text-gray-500 font-[400]'>Recorded by:</span> <Link className='text-gray-600 font-[550]' to={`/admin/college-staff/${item.createdBy._id}`}>{`${item.createdBy?.fullName}`}</Link></p>
            {/* <p className='text-sm text-gray-500'>{staff.email}, {staff?.phone}</p> */}
          </div>,
          students: <div className='flex items-center gap-x-[5px] flex-wrap'>{item.students.map((student, studentIndex) => {
            return <span key={studentIndex} className='p-[5px] rounded bg-gray-100 text-xs font-space-grotesk mb-[5px] inline-block'>{student.fullName}</span>
          })}</div>,
          penalty: <div className='w-full'>
            <PenaltyTypePill type={item.penalty.type} />
          </div>,
          penaltyStatus: <StatusPill status={item.penalty.status} />,
          // createdBy: <Link to={`/admin/college-staff/${item.createdBy._id}`}><StaffTableSnippet staff={item.createdBy} /></Link>,
          dateRecorded: <p className='text-sm text-gray-600'>{moment(item.createdAt).format('MMMM Do YYYY')}<br/><span className='text-gray-400 text-xs'>{moment(item.createdAt).format('h:mm a')}</span></p>
        },
      )
    })

    return data
  }

  const [readingDisciplinaryRecord, setReadingDisciplinaryRecord] = useState(false)
  const [activeDisciplinaryRecord, setActiveDisciplinaryRecord] = useState(null)

  const openDisciplinaryRecord = (record) => {
    setActiveDisciplinaryRecord(record)
    setTimeout(() => {
      setReadingDisciplinaryRecord(true)
    }, 200);
  }

  const closeDisciplinaryRecord = () => {
    setReadingDisciplinaryRecord(false)
    setTimeout(() => {
      setActiveDisciplinaryRecord(false)
    }, 200);
  }

  return (
    <>
      <div className="w-full">
        <div className='pb-3 mb-2'>
            <div className="w-full mx-auto">
                <div className='w-full flex items-center justify-between'>
                  <div className='w-2/3'>
                    <h4 className='font-medium text-lg mb-3 text-gray-400'>Disciplinary records for {student.firstName}</h4>
                    <div className=''>
                      <p className='text-gray-500 mt-1 text-sm'>
                        All disciplinary records and actions for this student.
                      </p>
                    </div>
                  </div>
                  {/* <button onClick={()=>{setAddingRecord(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    Add disiciplinary record
                  </button> */}
                </div>

                <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                    <div className='w-full'>
                        {/* <InvoicesFilters applyFilters={(filters)=>{
                            console.log('filters => ', filters)
                            setFilters(filters)
                        }} 
                        /> */}
                    </div>
                    <div className='w-full flex flex-row-reverse gap-x-2'>
                        <div className='w-[350px]'>
                            <SearchField 
                                placeholderText={`Search for record`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{}}
                                performingSearch={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className=''>
          {disciplinaryRecordsSelector?.loadingDisciplinaryRecords
          ? 
            <div className='w-full'>
              <Loader />
            </div>
          : 
            disciplinaryRecordsSelector?.disciplinaryRecords?.records?.length > 0 ? <>
              <div className='w-full hidden xl:block'>
                <DataTable
                  tableHeaders={tableHeadersFields(cleanupData(disciplinaryRecordsSelector?.disciplinaryRecords?.records)[0]).headers} 
                  tableData={cleanupData(disciplinaryRecordsSelector?.disciplinaryRecords?.records)} 
                  columnWidths={columnWidths}
                  columnDataStyles={columnDataStyles}
                  allFields={tableHeadersFields(cleanupData(disciplinaryRecordsSelector?.disciplinaryRecords?.records)[0]).fields}
                  onSelectItems={()=>{}}
                  tableOptions={tableOptions}
                  pagination={{
                    perPage: pagination.perPage, 
                    currentPage: pagination.page,
                    totalItems: disciplinaryRecordsSelector.disciplinaryRecords?.total,
                  }}
                  changePage={(page) => {setPagination({...pagination, ...{page: page}})}}
                  updatePerPage={(perPage) => {setPagination({...pagination, ...{perPage: perPage}})}}
                />
              </div>
            <div className='w-full xl:hidden space-y-3'>
              {disciplinaryRecordsSelector?.disciplinaryRecords?.records?.map((record, index) => (
                <div 
                  key={index}
                  onClick={() => openDisciplinaryRecord(record)}
                  className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow'
                >
                  <div className='mb-3'>
                    <p className='text-sm text-gray-700 mb-2'>
                      {record.description.substring(0, 150)}
                      {record.description.length > 150 ? '...' : ''}
                    </p>
                    <p className='text-xs text-gray-500'>
                      Recorded by: <span className='text-gray-700 font-medium'>{record.createdBy?.fullName}</span>
                    </p>
                  </div>

                  <div className='space-y-2 mb-3'>
                    {record.students.length > 1 && (
                      <div>
                        <span className='text-xs text-gray-600 block mb-1'>Students</span>
                        <div className='flex flex-wrap gap-1'>
                          {record.students.map((studentItem, studentIndex) => (
                            <span 
                              key={studentIndex} 
                              className='px-2 py-1 rounded bg-gray-100 text-xs font-space-grotesk'
                            >
                              {studentItem.fullName}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    <div className='flex justify-between items-center'>
                      <span className='text-xs text-gray-600'>Penalty</span>
                      <PenaltyTypePill type={record.penalty.type} />
                    </div>
                    
                    <div className='flex justify-between items-center'>
                      <span className='text-xs text-gray-600'>Status</span>
                      <StatusPill status={record.penalty.status} />
                    </div>
                  </div>

                  <div className='pt-2 border-t border-gray-100'>
                    <p className='text-xs text-gray-500'>
                      {moment(record.createdAt).format('MMMM Do YYYY')} at {moment(record.createdAt).format('h:mm a')}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            </>
            :
            <div>
              <EmptyState emptyStateText={`No disciplinary records created for ${student.firstName} ${student.lastName} yet`} />
            </div>
          }
        </div>
      </div>

      {/* <ModalDialog
        shown={addingRecord} 
        closeFunction={()=>{setAddingRecord(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Add feedback for ${student.fullName}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <NewDisciplinaryRecord 
          close={()=>{setAddingRecord(false)}}
          student={student._id}
        />
      </ModalDialog> */}

      {activeDisciplinaryRecord && <ModalDialog
        shown={readingDisciplinaryRecord} 
        closeFunction={()=>{closeDisciplinaryRecord()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Disciplinary record for ${student.fullName}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <DisciplinaryRecordDetails 
          student={student} 
          record={activeDisciplinaryRecord} 
          close={()=>closeDisciplinaryRecord()} 
        />
      </ModalDialog>}
    </>
  )
}

export default StudentDisciplinary